import { isDate, isMatch, getMonth, getYear, parse } from "date-fns";
import { useState, useEffect } from "react";
import { DATE_STRING_FORMAT } from "../Constants/stringFormats";

export default function useFYPricingAsOfQuarter(initialValue, format) {
    const [pricingAsOfQuarter, setPricingAsOfQuarter] = useState(null);
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        const determinedFormat = format || DATE_STRING_FORMAT;
        var parsedDate = value;
        if (!isDate(value) && isMatch(value, determinedFormat)) {
            parsedDate = parse(value, determinedFormat, new Date());
        }
        else
        {
            parsedDate = new Date();
        }
        parsedDate.setDate(1);
        //Temp logic to handle change in treatment of YYYYQ inputs between FY2023 IPPS model (requires Fiscal Year YYYYQ input) and FY2024 IPPS model (requires Calendar Year YYYYQ)
        if (parsedDate.getFullYear() <= 2022 || (parsedDate.getFullYear() === 2023 && parsedDate.getMonth() < 9)) 
        {
           parsedDate.setMonth(parsedDate.getMonth() +3);
        }
        if (isDate(parsedDate))
        {
            setPricingAsOfQuarter(String(parsedDate.getFullYear()) + String(Math.floor(parsedDate.getMonth()/3)+1));
        }
        else
        {
            setPricingAsOfQuarter(null);
        }

    }, [value]); 

    return [pricingAsOfQuarter, setValue];
}